
import * as types from '../actions/actionTypes';
import initialState from './initialState';
export default function paymentMethodsReducer(state = initialState.payment, action) {
    switch (action.type) {
        case types.FETCH_PAYMENT_METHODS_LIST_SUCCESS:
            return { ...state, paymentsMethods: action.paymentsMethods };
        case types.RESET_PAYMENT_METHODS_LIST_SUCCESS:
            return { ...state, paymentsMethods: [] };
        case types.LOADING_PAYMENT_METHOD:
            return { ...state, isLoading: action.isLoading };
        default:
            return state;
    }
}